module.exports = __webpack_public_path__ + "img/waiter-w.4e99e134.svg";